const sta = {
  INSUFFICIENT_BALANCE: {
    message: 'Seu saldo é insuficiente',
    field: 'value',
    code: 'STA_1'
  },
  WITHDRAW_VALUE_REQUIRED: {
    message: 'Informe o valor a ser resgatado',
    field: 'value',
    code: 'STA_2'
  }
};

module.exports = sta;
